import { Anchor, Card, Grid, PasswordInput, Select, Text, TextInput } from '@mantine/core';
import LabeledSlider from '../../LabeledSlider';

const SettingsTabMessage = ({ domain, handleChange, type }) => {
  const isText = type === 'text';
  const senderKey = isText ? 'textMessageSender' : 'viberMessageSender';
  const userKey = isText ? 'textMessageSenderUser' : 'viberMessageSenderUser';
  const passKey = isText ? 'textMessageSenderPassword' : 'viberMessageSenderPassword';
  const maxPerDayKey = isText ? 'maxTextMessagesPerDay' : 'maxViberMessagesPerDay';
  const channelLabel = isText ? 'Text Messages' : 'Viber Messages';
  const displayNameKey = isText ? 'textDisplayName' : 'viberDisplayName';
  const displayNamePlaceholder = isText ? 'Sender shortcode' : 'Display name';
  const senderFieldLabels = {
    default: {
      userLabel: 'User Name',
      passLabel: 'Password',
      userPlaceholder: 'johndoe',
      passPlaceholder: '****',
      feedbackMessage: 'You need user name and password.',
    },
    infobip: {
      userLabel: 'Base URL',
      passLabel: 'API Key',
      userPlaceholder: 'https://api.infobip.com',
      passPlaceholder: 'your-api-key',
      feedbackMessage: 'You need Base URL, API Key and Sender.',
    },
    linkMobility: {
      userLabel: 'API Key',
      passLabel: 'API Secret',
      userPlaceholder: '****',
      passPlaceholder: '****',
      feedbackMessage: 'You need API Key and API Secret.',
    },
  };

  const senderOptions = [
    { label: '(none)', value: '' },
    { label: 'Mobica', value: 'mobica' },
    { label: 'Routee', value: 'routee' },
    type === 'text' && { label: 'Infobip', value: 'infobip' },
    type === 'text' && { label: 'Releva', value: 'aws' },
    { label: 'Link Mobility', value: 'linkMobility' },
  ].filter(Boolean);

  const sender = domain[senderKey];
  const { userLabel, passLabel, userPlaceholder, passPlaceholder, feedbackMessage } =
    senderFieldLabels[sender] || senderFieldLabels.default;

  const hasError = (!domain[userKey] && domain[passKey]) || (domain[userKey] && !domain[passKey]);

  return (
    <Card withBorder>
      <Card.Section p="md">
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Message Sender</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Select
              data={senderOptions}
              value={domain[senderKey] || ''}
              onChange={(value) => handleChange({ target: { name: senderKey, value } })}
            />
          </Grid.Col>
        </Grid>
        {domain[senderKey] === 'linkMobility' && (
          <>
            <Grid mb="md">
              <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
                <label>{isText ? 'SMS Sender (shortcode)' : 'Display name (shortcode)'}</label>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 8 }}>
                <TextInput
                  name={displayNameKey}
                  placeholder={displayNamePlaceholder}
                  value={domain[displayNameKey] || ''}
                  onChange={handleChange}
                />
              </Grid.Col>
            </Grid>
            <Grid mb="md">
              <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
                <label>Service Id</label>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 8 }}>
                <TextInput name="viberSenderId" value={domain.viberSenderId || ''} onChange={handleChange} />
                <Text size="xs" c="dimmed" mt="xs">
                  Service Id is shared between Viber and SMS Link Mobility configuration.
                </Text>
              </Grid.Col>
            </Grid>
          </>
        )}
        {!['aws'].includes(domain[senderKey]) && (
          <>
            <Grid mb="md">
              <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
                <label>{userLabel}</label>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 8 }}>
                <TextInput
                  name={userKey}
                  placeholder={userPlaceholder}
                  value={domain[userKey] || ''}
                  error={hasError ? feedbackMessage : null}
                  onChange={handleChange}
                />
              </Grid.Col>
            </Grid>
            <Grid mb="md">
              <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
                <label>{passLabel}</label>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 8 }}>
                <PasswordInput
                  name={passKey}
                  placeholder={passPlaceholder}
                  value={domain[passKey] || ''}
                  error={hasError ? feedbackMessage : null}
                  onChange={handleChange}
                />
                {domain[senderKey] === 'infobip' ? (
                  <Text size="xs" c="dimmed" mt="xs">
                    You can find it in your Infobip account dashboard
                  </Text>
                ) : domain[senderKey] === 'linkMobility' ? null : (
                  <Text size="xs" c="dimmed" mt="xs">
                    Contact <Anchor href="mailto:support@releva.ai">support@releva.ai</Anchor> to get credentials.
                  </Text>
                )}
              </Grid.Col>
            </Grid>
          </>
        )}
        {domain[senderKey] === 'routee' && (
          <Grid mb="md">
            <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
              <label>Viber Sender Id</label>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 8 }}>
              <PasswordInput
                name="viberSenderId"
                placeholder="****"
                value={domain.viberSenderId || ''}
                onChange={handleChange}
              />
              <Text size="xs" c="dimmed" mt="xs">
                You can find it in your Routee account dashboard
              </Text>
            </Grid.Col>
          </Grid>
        )}
        {domain[senderKey] === 'infobip' && (
          <Grid mb="md">
            <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
              <label>Sender name</label>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 8 }}>
              <TextInput
                name="infobipSender"
                placeholder="InfoSMS"
                value={domain.infobipSender || ''}
                onChange={handleChange}
              />
              <Text size="xs" c="dimmed" mt="xs">
                This is the sender name displayed on your customers handset. Please copy/paste it from your Infobip
                account.
              </Text>
            </Grid.Col>
          </Grid>
        )}
        {domain[senderKey] === 'linkMobility' && (
          <Grid mb="md">
            <Grid.Col span={{ base: 12, sm: 2 }}></Grid.Col>
            <Grid.Col span={{ base: 12, sm: 8 }}>
              <Text size="xs" c="dimmed">
                This information is available in your Link Mobility account dashboard. Link Mobility will provide you
                with: API key, API secret, Service ID, and your registered shortcodes (Display names).
              </Text>
            </Grid.Col>
          </Grid>
        )}
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Max {channelLabel} Per Day</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <LabeledSlider
              min={1}
              max={10}
              value={domain[maxPerDayKey]}
              onChange={(value) => handleChange({ target: { name: maxPerDayKey, value } })}
            />
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default SettingsTabMessage;
